import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabase';

export default function Logo() {
  const [logoUrl, setLogoUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchLogo() {
      try {
        const { data, error } = await supabase
          .from('app_settings')
          .select('logo_url')
          .eq('id', 1)
          .single();
        
        if (error) throw error;
        setLogoUrl(data?.logo_url || 'https://images.unsplash.com/photo-1495195134817-aeb325a55b65?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1776&q=80');
      } catch (error) {
        console.error('Error fetching logo:', error);
        // Use default logo on error
        setLogoUrl('https://images.unsplash.com/photo-1495195134817-aeb325a55b65?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1776&q=80');
      } finally {
        setLoading(false);
      }
    }

    fetchLogo();
  }, []);

  // Show loading state
  if (loading) {
    return (
      <div className="flex items-center gap-2">
        <div className="w-10 h-10 bg-primary-50 rounded-full animate-pulse" />
        <div className="h-6 w-32 bg-primary-50 rounded animate-pulse" />
      </div>
    );
  }

  // Show logo
  return (
    <div className="flex items-center gap-2">
      <img 
        src={logoUrl}
        alt="Recipe Raccoon"
        className="h-10 w-auto rounded-lg"
        onError={() => {
          // Fallback to default logo on error
          setLogoUrl('https://images.unsplash.com/photo-1495195134817-aeb325a55b65?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1776&q=80');
        }}
      />
      <span className="text-xl font-bold text-primary-900">Recipe Raccoon</span>
    </div>
  );
}